export default {
  SET_CLASS_DATA: (state, payload) => {
    state.classItems = payload
  },
  SET_POSTS: (state, payload) => {
    state.posts = payload
  },
  SET_FILES: (state, payload) => {
    state.files = payload
  }
}


// WEBPACK FOOTER //
// ./src/store/Student/mutations.js